import React, { Component } from "react";

import { Input, SelectField, Array } from "react-invenio-forms";
import { Grid, Form, Button, Icon } from "semantic-ui-react";

const newTubitakGrants = {
    project_number: "",
    workgroup: {
        text:"",
        value:"",
    },
    program: {
        text: "",
        value:""
    },
};
const workgroups =

    [
        {
            "text": "ARGES -- AR-GE Destek ve Süreç Yönetim Hizmetleri Grubu",
            "value": "ARGES"
        },
        {
            "text": "ÇAYDAG -- Çevre, Atmosfer, Yer ve Deniz Bilimleri Araştırma Destek Grubu",
            "value": "ÇAYDAG"
        },
        {
            "text": "EEEAG -- Elektrik, Elektronik ve Enformatik Araştırma Destek Grubu",
            "value": "EEEAG"
        },
        {
            "text": "KAMAG -- Kamu Araştırmaları Destek Grubu",
            "value": "KAMAG"
        },
        {
            "text": "KBAG -- Kimya ve Biyoloji Araştırma Destek Grubu",
            "value": "KBAG"
        },
        {
            "text": "MAG -- Mühendislik Araştırma Destek Grubu",
            "value": "MAG"
        },
        {
            "text": "MFAG -- Matematik, Fizik Araştırma Destek Grubu",
            "value": "MFAG"
        },
        {
            "text": "SAVTAG -- Savunma ve Güvenlik Teknolojileri Araştırma Destek Grubu",
            "value": "SAVTAG"
        },
        {
            "text": "SBAG -- Sağlık Bilimleri Araştırma Destek Grubu",
            "value": "SBAG"
        },
        {
            "text": "SOBAG -- Sosyal ve Beşeri Bilimler Araştırma Destek Grubu",
            "value": "SOBAG"
        },
        {
            "text": "TOVAG -- Tarım, Ormancılık ve Veterinerlik Araştırma Destek Grubu",
            "value": "TOVAG"
        },
        {
            "text": "UPAG -- Uluslararası İşbirliği Projeleri Araştırma Destek Grubu",
            "value": "UPAG"
        }
    ]
const programs =

    [
        {
            "text": "1000 -- Üniversitelerin Araştırma ve Geliştirme Potansiyelinin Arttırılmasına Yönelik Destek Programı",
            "value": "1000"
        },
        {
            "text": "1001 -- Bilimsel ve Teknolojik Araştırma Projelerini Destekleme Programı",
            "value": "1001"
        },
        {
            "text": "1002 -- Hızlı Destek Programı",
            "value": "1002"
        },
        {
            "text": "1003 -- Öncelikli Alanlar Ar-Ge Projeleri Destekleme Programı",
            "value": "1003"
        },
        {
            "text": "1004 -- Mükemmeliyet Merkezi Destek Programı",
            "value": "1004"
        },
        {
            "text": "1005 -- Ulusal Yeni Fikirler ve Ürünler Araştırma Destek Programı",
            "value": "1005"
        },
        {
            "text": "1007 -- Kamu Kurumları Araştırma ve Geliştirme Projelerini Destekleme Programı",
            "value": "1007"
        },
        {
            "text": "1505 -- Üniversite-Sanayi İşbirliği Destek Program",
            "value": "1505"
        },
        {
            "text": "2515 -- COST Bilim ve Teknolojide Avrupa İşbirliği Programı",
            "value": "2515"
        },
        {
            "text": "2519 -- COST Çalışma Grubu Destek Programı",
            "value": "2519"
        },
        {
            "text": "3001 -- Başlangıç Ar-Ge Projeleri Destekleme Programı",
            "value": "3001"
        },
        {
            "text": "3501 -- Kariyer Geliştirme Programı" ,
            "value": "3501"
        },
        {
            "text": "Diğer",
            "value": "DIGER"
        },
    ]
export class TubitakGrants extends Component {

    render() {
        const {
            fieldPath, // injected by the custom field loader via the `field` config property
            project_number,
            workgroup,
            program,
            icon,
            addButtonLabel,
            description,
            label,
        } = this.props;
        return (
            <Array
                fieldPath={fieldPath}
                label={label}
                icon={icon}
                addButtonLabel={addButtonLabel}
                defaultNewValue={newTubitakGrants}
                description={description}
            >
                {({ arrayHelpers, indexPath }) => {
                    const fieldPathPrefix = `${fieldPath}.${indexPath}`;
                    return (
                        <Grid>
                            <Grid.Column width="5">
                                <Input
                                    fieldPath={`${fieldPathPrefix}.project_number`}
                                    label={project_number.label}
                                    required={true}
                                    placeholder={project_number.placeholder}
                                    description={project_number.description}
                                ></Input>
                            </Grid.Column>
                            <Grid.Column width="5">
                                <SelectField
                                    options={workgroups}
                                    fieldPath={`${fieldPathPrefix}.workgroup`}
                                    label={workgroup.label}
                                    placeholder={workgroup.placeholder}
                                    description={workgroup.description}
                                    required={true}
                                />
                            </Grid.Column>
                            <Grid.Column width="5">
                                <SelectField
                                    options={programs}
                                    fieldPath={`${fieldPathPrefix}.program`}
                                    label={program.label}
                                    required={true}
                                    placeholder={program.placeholder}
                                    description={program.description}
                                ></SelectField>
                            </Grid.Column>
                            <Grid.Column width="1">
                                <Form.Field style={{ marginTop: "1.75rem", float: "right" }}>
                                    <Button
                                        aria-label={"Remove field"}
                                        className="close-btn"
                                        icon
                                        onClick={() => arrayHelpers.remove(indexPath)}
                                        type="button"
                                    >
                                        <Icon name="close" />
                                    </Button>
                                </Form.Field>
                            </Grid.Column>
                        </Grid>
                    );
                }}
            </Array>
        );
    }
}